module.exports = __webpack_public_path__ + "img/up.bc508582.svg";